import React from 'react';
import Contact from '../components/Contact';
import { useViewTracking } from '../hooks/useViewTracking';

const ContactPage: React.FC = () => {
  useViewTracking({ viewType: 'contact' });

  return <Contact />;
};

export default ContactPage;
